import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useCategoryStore } from "@/stores/categoryStore";
import { CategoryForm } from "./CategoryForm";
import { useCreateCategory } from '@/hooks/useCategories';
import { toast } from "sonner";
import type { CategoryFormData } from "../types";
import { EditCategoryModal } from './EditCategoryModal';

interface CategoryModalsProps {
  providerId: number;
  versionId: number;
}

export function CategoryModals({ providerId, versionId }: CategoryModalsProps) {
  const { isCreateModalOpen, closeCreateModal } = useCategoryStore();
  const createCategory = useCreateCategory();
  const isCreating = createCategory.isPending;

  const handleSubmit = async (data: CategoryFormData) => {
    try {
      await createCategory.mutateAsync({
        name: data.name,
        parentId: data.parentId ?? null,
        displayOrder: data.displayOrder ?? 0,
        providerId,
        versionId,
        price: data.price,
        description: data.description
      });
      toast.success("Category created successfully");
      closeCreateModal();
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Failed to create category");
    }
  };

  return (
    <>
      <Dialog open={isCreateModalOpen} onOpenChange={closeCreateModal}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Create Category</DialogTitle>
          </DialogHeader>
          <CategoryForm
            providerId={providerId}
            versionId={versionId}
            onSubmit={handleSubmit}
            isSubmitting={isCreating}
            onCancel={closeCreateModal}
          />
        </DialogContent>
      </Dialog>
      <EditCategoryModal providerId={providerId} versionId={versionId} />
    </>
  );
} 